import React from 'react';
import { HomeOutlined, StarOutlined, SwapOutlined, TeamOutlined } from '@ant-design/icons';
import type { DisplayGroup } from '../constants';
import GroupInfoPopover from './GroupInfoPopover';
import ConditionalRender from '../../ConditionalRender';
import styles from './userGroups.module.scss';

const ICONS: Record<NonNullable<DisplayGroup['icon']>, React.ReactNode> = {
  housing: <HomeOutlined />,
  manager: <StarOutlined />,
  lands: <SwapOutlined />,
};

interface UserGroupsProps {
  groups: DisplayGroup[];
  canEdit?: boolean;
  onEditClick?: () => void;
}

const UserGroups: React.FC<UserGroupsProps> = ({ groups, canEdit = false, onEditClick }) => {
  return (
    <section className={styles.section} aria-labelledby="profile-user-groups">
      <h2 className={styles.heading} id="profile-user-groups">
        Your Groups
      </h2>

      <ul className={styles.list}>
        {groups.map((group) => (
          <li className={styles.item} key={group.id}>
            <GroupInfoPopover group={group}>
              <div className={styles.groupTrigger}>
                <span className={styles.icon}>{group.icon ? ICONS[group.icon] : <TeamOutlined />}</span>
                <span className={styles.name}>{group.name}</span>
              </div>
            </GroupInfoPopover>
          </li>
        ))}

        <ConditionalRender visible={canEdit} hideFallback>
          <li className={styles.item}>
            <button type="button" className={styles.editButton} onClick={onEditClick}>
              <span className={styles.name}>Edit Groups</span>
            </button>
          </li>
        </ConditionalRender>
      </ul>
    </section>
  );
};

export default UserGroups;
